export default {
    lists:[
        {
          type: 'list',
          listName: 'Inbox',
          items: [
            {
              type: 'url',
              site: 'www.recipes.com',
              title: 'Software Development',
              description: 'This is the description',
              url: 'http://recipes.com',
              img: 'http://rialab.net/assets/img/rialab.png'
            },
            {
              type: 'url',
              site: 'www.si.com',
              title: 'Sports Magazine',
              description: 'This is the description',
              url: 'http://si.com',
              img: 'http://rialab.net/assets/img/bg-quote.jpg'
            }
          ]
        },
        {
          type: 'list',
          listName: 'Travel',
          items: [
            {
              type: 'url',
              site: 'www.destinations.com',
              title: 'Italy',
              description: 'This is the description',
              url: 'http://italy.com',
              img: 'https://qph.fs.quoracdn.net/main-qimg-d188e577860c71b75b68adc7dd87c11e'
            },
            {
              type: 'url',
              site: 'www.tripadvisor.com',
              title: 'Peru',
              description: 'This is the description',
              url: 'http://peru.com',
              img: 'https://perureports.com/wp-content/uploads/2018/07/peru-2774925_960_720.jpg'
            },
            {
              type: 'url',
              site: 'en.wikipedia.org',
              title: 'Chile - Wikipedia',
              description: '',
              url: 'https://en.wikipedia.org/wiki/Chile',
              img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Flag_of_Chile.svg/1200px-Flag_of_Chile.svg.png'
            }
          ]
        },
        {
          type: 'list',
          listName: 'Music',
          items: [
            {
              type: 'url',
              site: 'www.youtube.com',
              title: 'Mark Knopfler on Guitars',
              description: 'Taken from Soundbreaking documentary c2016 Higher Ground LLC vk.com/markknopfler',
              url: 'https://www.youtube.com/watch?v=OG__SwkV3wg',
              img: 'https://i.ytimg.com/vi/OG__SwkV3wg/maxresdefault.jpg'
            },
            {
              type: 'url',
              site: 'www.sting.com',
              title: 'Latest Show Review',
              description: 'This is the description',
              url: 'http://sting.com',
              img: 'https://static01.nyt.com/images/2018/11/24/arts/24brief-sting/merlin_143817111_f847f883-a893-422a-86ab-ce2ae65be432-articleLarge.jpg?quality=75&auto=webp&disable=upscale'
            },
            {
              type: 'url',
              site: 'www.johnmayer.com',
              title: 'His Signature Guitar',
              description: 'This is the description',
              url: 'http://johnmayer.com',
              img: 'https://www.ultimate-guitar.com/static/article/news/7/77937_0_wide_ver1533562230.jpg@642'
            }
          ]
        },
        {
          type: 'list',
          listName: 'Food',
          items: [
            {
              type: 'url',
              site: 'www.artisankitchenandbar.com',
              title: 'Menus | Artisan Kitchen and Bar',
              description: 'About Handcrafted food+ specials craft beers+select wine / try some different lunch everyday changes + live music on Friday.',
              url: 'https://www.artisankitchenandbar.com/menus/#dinner',
              img: 'https://images.getbento.com/accounts/717e5b2cd0cedaac3881824b7358d689/media/9hgqBMU0SJuIIjb7yIVW_Artisan-133-X2.jpg?w=1200&fit=crop&auto=compress,format&h=600'
            },
            {
              type: 'url',
              site: 'www.eater.com',
              title: 'Best Restaurants 2019',
              description: 'The best restaurants of 2019',
              url: 'https://www.foodandwine.com/travel/restaurants/best-new-restaurants-2019',
              img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfYCCWTbC1yw2Aj1hHXa9KAOq0tb5DSGkpYMv0bibA72OcdZKbLw'
            },
            {
              type: 'url',
              site: 'www.bugers.com',
              title: '11 Essential Burgers',
              description: 'This is the description',
              url: 'http://burgers.com',
              img: 'https://cdn.vox-cdn.com/uploads/chorus_image/image/57780105/the_local_credit_restaurant.0.png'
            }
          ]
        },
        {
          type: 'list',
          listName: 'Books',
          items: [
            {
              type: 'url',
              site: 'www.harrypotter.com',
              title: 'Harry Potter',
              description: 'This is the description',
              url: 'http://harrypotter.com.com',
              img: 'https://melbournesymphonyorchestra-assets.s3.amazonaws.com/assets/Image/4813-fitandcrop-486x486.jpg'
            },
            {
              type: 'url',
              site: 'www.nytimes.com',
              title: 'An American Pilot, a Muslim Teenager and a Talking Dog All Caught in an Absurd War - The New York Times',
              description: '',
              url: 'https://www.nytimes.com/2019/05/18/books/review/mohammed-hanif-red-birds.html',
              img: 'https://static01.nyt.com/images/2019/05/26/books/review/26Mahajan/26Mahajan-articleLarge.jpg?quality=75&auto=webp&disable=upscale'
            }
          ]
        }
      ],
    blanks: {
        list: {
            type:'list',
            listName: '',
            items:[]
        }
    }

}